module.exports = __webpack_public_path__ + "img/20190603162700QQ截图20190524162941.20d7dd5c.png";